export default ":host {\n  position: unset;\n}"